import { createContext, useContext } from "react";

import { type RowData } from "@tanstack/react-table";

import { type BulkActionBarContextType } from "../types";

export const BulkActionBarContext = createContext<
  BulkActionBarContextType<RowData>
>({
  selectAllRows: () => null,
  selectedRows: [],
  totalRows: 0
});

export const useBulkActionBar = () => useContext(BulkActionBarContext);
